(function () {
  'use strict';

  function setActive(root, item) {
    root.querySelectorAll('[data-adtf-item]').forEach((currentItem) => {
      const isActive = currentItem === item;
      currentItem.classList.toggle('is-active', isActive);
      currentItem.querySelector('[data-adtf-trigger]')?.classList.toggle('is-active', isActive);
      const answer = currentItem.querySelector('.adtf-answer-card');
      if (answer) answer.hidden = !isActive;
    });
  }

  function initSection(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    root.querySelectorAll('[data-adtf-item]').forEach((item) => {
      const button = item.querySelector('[data-adtf-trigger]');
      if (!button) return;
      button.addEventListener('click', () => setActive(root, item));
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ask-dr-teo-faq]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ask-dr-teo-faq]').forEach(initSection);
  });
})();
